<template>
	<header class="page-header header">
		<div class="header__logo">
			<a class="header-logo" href="/">
				<img src="../assets/logo.jpg" alt="Logo company">
			</a>
		</div>
		<div class="header__info">
			<div class="user-info">
				<div class="user-info__avatar">
					<img src="../assets/icons/icon-avatar.jpg" alt="Иннокентий Ф.">
				</div>
				<div class="user-info__row">
					<span class="user-info__name">Иннокентий Ф.</span>
					<span class="user-info__account-number">Счет: #62946480</span>
				</div>
				<Balance/>
			</div>
		</div>
		<div class="header__tumbnail">
			<img src="../assets/icons/icon-bitcoin.svg" alt="Bitcoin">
		</div>
	</header>
</template>

<script>
	import Balance from "./Balance";
	export default {
		name: "Header",
		components: {Balance}
	}
</script>
